import { getReduxStore } from '../redux/reduxStore'
import { requestFailed } from '../order/actions'
import { genericImportantError } from '@/checkout-instore-legacy/utils/EventHelper'
import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'

export default function loadScript(src, retries = 0) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = src
  script.addEventListener('error', () => handleError(src, retries), false)
  script.addEventListener('load', () => handleLoad(src), false)
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(script, s)
}

function handleError(src, retries) {
  if (retries > 0) {
    loadScript(src, retries - 1)
  } else {
    onErrorLoadingCriticalAssets()
  }
}

function handleLoad(src) {
  CustomEvent.sendEvent('load.instore-custom', { src })
}

function onErrorLoadingCriticalAssets() {
  genericImportantError('failed-loading-critical-assets', {
    context: 'Internal',
    asset: 'custom-scripts',
  })
  getReduxStore().dispatch(
    requestFailed({
      message: 'Não foi possível carregar algumas funcionalidades desta loja',
      onRetry: () => window.location.reload(),
    })
  )
}
